import { render, staticRenderFns } from "./ChangeReqApplicationList.vue?vue&type=template&id=ed23aa8c&lang=html&"
import script from "./ChangeReqApplicationList.vue?vue&type=script&lang=js&"
export * from "./ChangeReqApplicationList.vue?vue&type=script&lang=js&"
import style0 from "./ChangeReqApplicationList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports